import { SVGProps } from "react";

const KensakuKun = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={24}
    height={25}
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_180_8852)">
      <path
        d="M12 6.5C12 7.03043 12.2107 7.53914 12.5858 7.91421C12.9609 8.28929 13.4696 8.5 14 8.5C14.5304 8.5 15.0391 8.28929 15.4142 7.91421C15.7893 7.53914 16 7.03043 16 6.5C16 5.96957 15.7893 5.46086 15.4142 5.08579C15.0391 4.71071 14.5304 4.5 14 4.5C13.4696 4.5 12.9609 4.71071 12.5858 5.08579C12.2107 5.46086 12 5.96957 12 6.5Z"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 6.5H12"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 6.5H20"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 12.5C6 13.0304 6.21071 13.5391 6.58579 13.9142C6.96086 14.2893 7.46957 14.5 8 14.5C8.53043 14.5 9.03914 14.2893 9.41421 13.9142C9.78929 13.5391 10 13.0304 10 12.5C10 11.9696 9.78929 11.4609 9.41421 11.0858C9.03914 10.7107 8.53043 10.5 8 10.5C7.46957 10.5 6.96086 10.7107 6.58579 11.0858C6.21071 11.4609 6 11.9696 6 12.5Z"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 12.5H6"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 12.5H20"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 18.5C15 19.0304 15.2107 19.5391 15.5858 19.9142C15.9609 20.2893 16.4696 20.5 17 20.5C17.5304 20.5 18.0391 20.2893 18.4142 19.9142C18.7893 19.5391 19 19.0304 19 18.5C19 17.9696 18.7893 17.4609 18.4142 17.0858C18.0391 16.7107 17.5304 16.5 17 16.5C16.4696 16.5 15.9609 16.7107 15.5858 17.0858C15.2107 17.4609 15 17.9696 15 18.5Z"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 18.5H15"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19 18.5H20"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_180_8852">
        <rect
          width={24}
          height={24}
          fill="currentColor"
          transform="translate(0 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);
export default KensakuKun;
